// TODO: move to constants

// eslint-disable-next-line import/prefer-default-export
export const AUTH_API = 'AUTH_API';
